<template>
  <div class="">
    <div class="neiye_banner">
      <BANNER></BANNER>
    </div>
    <div class="main">
      <div class="container">
        <div class="location">
          <router-link to="/">网站首页</router-link>
          <router-link to="/yygk/home">&nbsp;&gt;&nbsp;医院简介</router-link>
          <router-link to="/yygk/lianmeng"
            >&nbsp;&gt;&nbsp;盛京医疗联盟</router-link
          >
        </div>
        <div class="tv_main clearfix">
          <div class="sjjj_main_left fl">
            <SLIDE></SLIDE>
          </div>
          <div class="sjhy_main_right fr">
            <ul class="neiye_news_ul">
              <li
                @click="goArticle(item)"
                v-for="(item, index) in list"
                :key="index"
              >
                <span class="fl">{{ item.title }}</span
                ><span class="fr">【{{ item.releaseDate }}】</span>
              </li>
            </ul>
            <nav>
              <Pagination
                :pageCount="totalPages"
                :total="total"
                @togglePage="togglePage($event)"
              ></Pagination>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/yygk";
import BANNER from "../../components/banner/yygk";
export default {
  name: "LIANMENG",
  data() {
    return {
      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      totalPages: 1,
      currentPage: 1,
      list: [],
      total: 0,
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getHosOverviewUnionList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substring(0, 10)
              : "";
          });
        }
        this.totalPages = parseInt(res.totalPages) || 0;
        this.total = res.totalElements;
        this.list = res.content || [];
      });
    },
    goArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        this.$router.push({
          path: `/yygk/lianmeng/article`,
          query: {
            id: e.id,
          },
        });
      }
    },
    togglePage(index) {
      this.pageIndex = index;
      this.init();
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>
